import ModalContext from './modal-context';


class MenuContext extends ModalContext {}


export default MenuContext;
